import animationData from './sticker.json'
import ErrorScreen from '../ErrorScreen'

export default function MiniAppRuntimeFailure() {
	return (
		<ErrorScreen
			header="Open in Telegram"
			description="Hillary's Empire is a Telegram mini app and needs to be run in Telegram. Download Telegram or visit the web version, and then start this mini app by finding @HillarysEmpireBot using the search bar."
			lottieAnimationData={animationData}
		/>
	)
}
